export const PLAYER_ICON = String.fromCodePoint(0x1F642);
export const MISSILE_ICON = String.fromCodePoint(0x1F680);
export const BALL_ICON = String.fromCodePoint(0x26BD);
export const HORIZONTAL_ICON = String.fromCodePoint(0x2194) + String.fromCodePoint(0xFE0F);
export const VERTICAL_ICON = String.fromCodePoint(0x2195) + String.fromCodePoint(0xFE0F);
export const COLOR_ICON = String.fromCodePoint(0x1F3A8);
export const HEIGHT_ICON = String.fromCodePoint(0x1F4CF);
export const JOYSTICK_ICON = String.fromCodePoint(0x1F579);
export const FIRE_ICON = String.fromCodePoint(0x1F518);
export const KEYPAD_ICON = String.fromCodePoint(0x1F522);
export const PLAYFIELD_ICON = String.fromCodePoint(0x1F5FA);
export const SCORE_ICON = String.fromCodePoint(0x1F4AF);
export const BACKGROUND_ICON = String.fromCodePoint(0x1F304);
export const DICE_ICON = String.fromCodePoint(0x1F3B2);
export const SOUND_ICON = String.fromCodePoint(0x1F509);
export const ANIMATION_ICON = String.fromCodePoint(0x1F3AC);
export const VISIBILITY_ICON = String.fromCodePoint(0x1F440);
export const MIRROR_ICON = String.fromCodePoint(0x1FA9E);
export const SYSTEM_ICON = String.fromCodePoint(0x1F3AB);
export const START_ICON = String.fromCodePoint(0x25B6) + String.fromCodePoint(0xFE0F);
export const TITLE_ICON = String.fromCodePoint(0x1F4FA);
export const UPDATE_ICON = String.fromCodePoint(0x1F3C3);
export const GAME_ICON = String.fromCodePoint(0x1F47E);
export const GAMEOVER_ICON = String.fromCodePoint(0x2620) + String.fromCodePoint(0xFE0F);
export const CHECKBOX_CHECKED_ICON = String.fromCodePoint(0x2611);
export const CHECKBOX_CLEAR_ICON = String.fromCodePoint(0x2610);
export const TEXT_ICON = String.fromCodePoint(0x1F4DD);
export const FLIP_ICON = String.fromCodePoint(0x2194);

export const DIFFICULTY_ADVANCED_ICON = String.fromCodePoint(0x1F631);
export const DIFFICULTY_BEGINNER_ICON = String.fromCodePoint(0x1F476);
export const CONSOLE_SWITCH_ICON = String.fromCodePoint(0x1F39A) + String.fromCodePoint(0xFE0F);
export const CONSOLE_SWITCH_RESET_ICON = String.fromCodePoint(0x267B) + String.fromCodePoint(0xFE0F);
export const CONSOLE_SWITCH_SELECT_ICON = String.fromCodePoint(0x2754);
export const CONSOLE_SWITCH_COLOR_ICON = String.fromCodePoint(0x1F7E5);
export const CONSOLE_SWITCH_BW_ICON = String.fromCodePoint(0x1F532);
export const BACKGROUND_PFSCROLL_LEFT_ICON = String.fromCodePoint(0x2190);
export const BACKGROUND_PFSCROLL_RIGHT_ICON = String.fromCodePoint(0x2192);
export const BACKGROUND_PFSCROLL_UP_ICON = String.fromCodePoint(0x2191);
export const BACKGROUND_PFSCROLL_DOWN_ICON = String.fromCodePoint(0x2193);
export const BACKGROUND_PFSCROLL_UP2X_ICON = String.fromCodePoint(0x21C8);
export const BACKGROUND_PFSCROLL_DOWN2X_ICON = String.fromCodePoint(0x21CA);
export const BIT_ICON = String.fromCodePoint(0x1F522);
export const DATA_ICON = String.fromCodePoint(0x1F5C4) + String.fromCodePoint(0xFE0F);
export const FRAME_ICON = String.fromCodePoint(0x1F39E) + String.fromCodePoint(0xFE0F);
export const PLAY_ICON = String.fromCodePoint(0x25B6) + String.fromCodePoint(0xFE0F);
export const PAUSE_ICON = String.fromCodePoint(0x23F8) + String.fromCodePoint(0xFE0F);
export const PRIORITY_ICON = String.fromCodePoint(0x1F5C2) + String.fromCodePoint(0xFE0F);
export const COMMENT_ICON = String.fromCodePoint(0x1F4AC);
export const MUSIC_ICON = String.fromCodePoint(0x1F3B5);
export const STOP_ICON = String.fromCodePoint(0x23F9) + String.fromCodePoint(0xFE0F);
export const SEEK_ICON = String.fromCodePoint(0x1F3AF);
export const LOCK_ICON = String.fromCodePoint(0x1F517);
export const INERTIA_ICON = String.fromCodePoint(0x1F4A8);
